export { default as Table } from "./components/Table";
export {
  default as TableProvider,
  initializeTableState
} from "./components/TableProvider";
export { default as columnConfig } from "./columnConfig";
export { default as useTableColumns } from "./useTableColumns";
export { default as useTableFilters } from "./useTableFilters";

import { TableState } from "./components/TableProvider";

export type TableState = TableState;
